<template>
  <div class="festival-page app-page">
    <v-img
      class="festival-page__header-img"
      height="100vh"
      gradient="to top left, rgba(142,142,142,0), rgba(142,142,142,0.3)"
      src="https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/banner-cover%2F1920_vietnei2.jpg?alt=media&token=e5686a09-d968-484d-a3f6-6927447ba184"
      lazy-src="https://firebasestorage.googleapis.com/v0/b/augam-vegan.appspot.com/o/banner-cover%2F1920_vietnei_lazy.jpg?alt=media&token=6932d777-8c48-4b22-af56-35573c3c14d1"
    ></v-img>
    <section class="punch-line-section">
      <div class="punch-line-tile">
        <div class="punch-line-tile__text custom-title-font">
          <div class="punch-line-tile__event-name">
            <span>AUGam</span><br />
            <div class="punch-line-tile__event-name--justified">
              ēdiena svētki
            </div>
          </div>
        </div>

        <!-- <div class="punch-line-tile__description custom-title-font">
          <div class="punch-line-tile__riga-year">
            14. jūlijs no plkst. 11 līdz 19
          </div>
          <div class="punch-line-tile__moto">Āgenskalna tirgus</div>
        </div> -->
        

        <div class="punch-line-tile__description custom-title-font">
          <div class="punch-line-tile__riga-year">
            Informāciju par gaidāmajiem pasākumiem un citus jaunumus meklē mūsu sociālo mediju kontos!
          </div>
        </div>
        
      </div>
    </section>

    <section class="description main-section">
      <div class="description__text">
        <!-- <p>
          Šīs vasaras augu valsts ēdiena svētki jūs priecēs 14. jūlijā
          Āgenskalna tirgū, Rīgā, kur svētku apmeklētājiem būs iespēja izbaudīt
          daudzveidīgo un pārsteidzošo augu valsts virtuvi zaļā un gaišā
          atmosfērā.
        </p>
        <br /> -->
        <p>
          Lai iepazīstinātu rīdziniekus un pilsētas viesus ar videi un
          dzīvniekiem draudzīgu ēdienu, biedrība AUGam rīko augu valsts ēdiena
          svētkus kas visas dienas garumā pasniegs dažnedažādus vegāniskus
          ēdienus vasaras noskaņās.
        </p>
        <br />
        <!-- <p>
          Iepazīsti, cik daudzveidīga un bagāta ir augu valsts virtuve! Gan
          burgeri un citas ātrās uzkodas, gan tuvo austrumu ēdieni, sojšliks, kā
          arī deserti un saldējums – viss, ko jau sen vēlies nogaršot, vienuviet
          – lielākajos pavasara ēdiena svētkos “AUGam”.
        </p>
        <br /> -->
        <p>
          Ēdiena svētki notiek četras reizes gadā, lai katrā gadalaikā piedāvātu
          iespēju izbaudīt augu valsts ēdiena sezonālo daudzveidību.
        </p>
      </div>
    </section>

    <!-- <section class="location main-section">
      <div class="background-img background-img__location"></div>
      <div class="background-overlay background-overlay__location"></div>
      <div class="location__content">
        <div class="location__map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2176.767775965874!2d24.068929677093053!3d56.9356460735448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46eed03da6be4445%3A0x4d679ef0bbcebb8e!2sAgenskalns%20Market!5e0!3m2!1sen!2slv!4v1718615718814!5m2!1sen!2slv"
            frameborder="0"
            style="border: 0"
            allowfullscreen
          >
          </iframe>
        </div>
        <div class="location__description">
          <p>Ēdiena svētki “AUGam”<br /></p>
          <p>2024. gada 14. jūlijā<br /></p>
          <p>plkst. 11.00-19.00<br /></p>
          <p>Āgenskalna tirgus, Rīga<br /></p>
          <p>Ieeja – bezmaksas<br /></p>
          <p>
            <a
              href="https://www.facebook.com/events/981265773548349"
              target="_blank"
              >Ēdiena svētku Facebook lapa</a
            >
          </p>
        </div>
      </div>
    </section> -->

    <section
      v-if="isAuthenticated"
      id="dalibnieki"
      class="caterers main-section"
    >
      <CatererBlock
        ref="currentEventCatererBlock"
        v-bind:catererCollection="currentEventCollection"
        v-bind:archived="false"
      ></CatererBlock>

      <!--            <v-flex>-->
      <!--                <v-card width="320px" height="335px">-->
      <!--                    <div class="caterers__more-caterers-card">-->
      <!--                        <v-card-title class="headline font-weight-bold">-->
      <!--                            <v-icon size="76">fastfood</v-icon>-->
      <!--                        </v-card-title>-->
      <!--                        <v-card-text class="headline">-->
      <!--                            <h2>Un vēl citi</h2>-->
      <!--                        </v-card-text>-->
      <!--                    </div>-->
      <!--                </v-card>-->
      <!--            </v-flex>-->

      <div class="caterers__add-more">
        <v-flex v-if="isAuthenticated" shrink>
          <v-dialog
            content-class="caterers__dialog"
            v-on:input="toggleDialogEvent($event)"
            lazy
            maxWidth="900px"
          >
            <template v-slot:activator="{ on }">
              <v-card v-on="on" width="320px">
                <v-card-title primary-title>
                  <div>
                    <div class="headline">Pievienot jaunu dalībnieku</div>
                  </div>
                </v-card-title>
              </v-card>
            </template>

            <v-card>
              <v-card-title primary-title>
                <div>
                  <div class="headline">Pievienot jaunu dalībnieku</div>
                </div>
              </v-card-title>

              <v-card-text>
                <v-form name="add-caterer-form" ref="addCatererFormRef">
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12 md4>
                        <v-text-field
                          v-model="addCatererFormData.name"
                          label="Uzņēmuma nosaukums"
                          required
                        >
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12 md4>
                        <v-text-field
                          v-model="addCatererFormData.offering"
                          label="Piedāvājums"
                          required
                        >
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12 md4>
                        <v-text-field
                          label="Logo bilde (jpg, jpeg, png)"
                          :value="logoUploadFileString"
                          readonly
                          prepend-inner-icon="attach_file"
                          @click="triggerLogoFileSelect"
                        >
                        </v-text-field>
                        <input
                          ref="uploadLogoRef"
                          accept=".png, .jpg, .jpeg"
                          style="display: none"
                          @change="logoFileListChange()"
                          type="file"
                        />
                      </v-flex>

                      <v-flex xs12 md4>
                        <v-text-field
                          v-model="addCatererFormData.instagram"
                          label="Instagram"
                        >
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12 md4>
                        <v-text-field
                          v-model="addCatererFormData.facebook"
                          label="Facebook"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout column>
                      <v-flex xs12 md4>
                        <v-text-field
                          label="Galerijas bildes (jpg, jpeg, png)"
                          :value="galleryUploadFileString"
                          readonly
                          prepend-inner-icon="attach_file"
                          @click="triggerGalleryFileSelect"
                        >
                        </v-text-field>
                        <input
                          ref="uploadGalleryRef"
                          accept=".png, .jpg, .jpeg"
                          style="display: none"
                          @change="galleryFileListChange()"
                          type="file"
                          multiple
                        />
                      </v-flex>
                    </v-layout>

                    <v-layout column>
                      <v-flex xs12 md4>
                        <v-textarea
                          v-model="addCatererFormData.description"
                          label="Apraksts"
                          required
                        >
                        </v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-show="!processingSubmit"
                  icon
                  @click="resetCatererForm"
                >
                  <v-icon>redo</v-icon>
                </v-btn>
                <v-btn v-show="!processingSubmit" icon @click="addCaterer">
                  <v-icon>done</v-icon>
                </v-btn>

                <v-progress-circular
                  v-show="processingSubmit"
                  indeterminate
                  color="green"
                ></v-progress-circular>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </div>
    </section>

    <!--        <section class="join-event main-section">-->
    <!--            <ApplyForm-->
    <!--                v-bind:participantsTable="'eventParticipants2020q3'"-->
    <!--            ></ApplyForm>-->
    <!--        </section>-->

    <section class="hosts main-section">
      <h1>Rīkotāji</h1>
      <div class="hosts__content">
        <div class="hosts__text">
          Ēdiena svētki ir nosaukti to rīkotājorganizācijas – biedrības “AUGam”
          – vārdā. Svētku organizatorisko komandu veido augu valsts ēdiena
          pazinēji ar pieredzi pasākumu organizēšanā. Lai iepazītu komandu vai
          skatītu kontaktinformāciju, apmeklē sadaļu
          <router-link class="router-link" to="/ParMums">Par mums</router-link>.
        </div>
      </div>
    </section>

    <!-- <section class="caterers">
      <div class="previous-events-container">
        <h1>Aizvadītie svētki</h1>
        <v-expansion-panels focusable popout>
          <v-expansion-panel class="caterers__expansion-panel">
            <v-expansion-panel-header
              >2020 rudens svētki</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <CatererBlock
                v-bind:catererCollection="'caterers2020q3'"
                v-bind:archived="true"
              >
              </CatererBlock>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="caterers__expansion-panel">
            <v-expansion-panel-header
              >2019 - 2020 ziemas svētki</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <CatererBlock
                v-bind:catererCollection="'caterers2019q4'"
                v-bind:archived="true"
              >
              </CatererBlock>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="caterers__expansion-panel">
            <v-expansion-panel-header
              >2019 rudens svētki</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <CatererBlock
                v-bind:catererCollection="'caterers2019q3'"
                v-bind:archived="true"
              >
              </CatererBlock>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="caterers__expansion-panel">
            <v-expansion-panel-header
              >2019 vasaras svētki</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <CatererBlock
                v-bind:catererCollection="'caterers'"
                v-bind:archived="true"
              >
              </CatererBlock>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </section> -->

    <!-- <section class="partners main-section">
      <h1>Atbalstītāji</h1>
      <v-lazy>
        <div class="partners__content">
          <div class="partner-item">
            <a href="https://vegfund.org" target="_blank">
              <img
                src="../assets/img/vegfund.png"
                alt="VegFund"
                title="VegFund"
              />
            </a>
          </div>
        </div>
      </v-lazy>
    </section> -->

    <v-snackbar
      style="position: fixed; top: 50px"
      v-model="notificationState"
      top
      absolute
      :color="notificationColor"
      >{{ notificationText }}</v-snackbar
    >
  </div>
</template>

<script>
import firebaseCfg from "../firebaseConfig";

import firebase from "firebase/app";
require("firebase/auth");
// import VueMarkdown from 'vue-markdown';

import CatererBlock from "../components/CaterersBlock";
// import ApplyForm from '../components/ApplyToEventForm'

document.addEventListener("scroll", () => {
  let pageTop = window.pageYOffset;
  const bannerDescription = document.querySelector(".punch-line-tile");
  if (pageTop > 20 && bannerDescription) {
    bannerDescription.classList.add("punch-line-tile--moved");
  }
});

export default {
  name: "FoodFest",
  components: {
    // CatererBlock, ApplyForm
    CatererBlock,
  },
  data() {
    return {
      isAuthenticated: false,
      currentEventCollection: "caterers2022q2",
      caterers: [],

      deleteDialog: false,
      deleteCatereriD: null,
      deleteName: null,

      processingSubmit: false,
      dialogOpen: false,
      logoUploadFileString: "",
      galleryUploadFileString: "",
      galleryFileList: null,
      logoFileList: null,
      addCatererFormData: {
        name: "",
        offering: "",
        description: "",
        instagram: "",
        facebook: "",
      },

      notificationState: false,
      notificationText: "",
      notificationColor: "",
    };
  },
  methods: {
    toggleDialogEvent: function (status) {
      this.$data.dialogOpen = status;
    },
    pushNotification: function (color, text) {
      this.notificationState = true;

      this.notificationColor = color;
      this.notificationText = text;
    },
    triggerLogoFileSelect: function () {
      this.$refs.uploadLogoRef.click();
    },
    logoFileListChange: function () {
      const that = this;
      const fileList = this.$refs.uploadLogoRef.files;

      that.logoUploadFileString = fileList[0].name;
      that.logoFileList = fileList;
    },
    triggerGalleryFileSelect: function () {
      this.$refs.uploadGalleryRef.click();
    },
    galleryFileListChange: function () {
      const that = this;
      const fileList = this.$refs.uploadGalleryRef.files;
      let fileNameString = "";

      Array.from(fileList).forEach(function (file) {
        fileNameString = fileNameString + file.name + " ";
      });

      that.galleryUploadFileString = fileNameString;
      that.galleryFileList = fileList;
    },
    uploadCatererImages: function (
      catererName,
      logoFile,
      galleryFiles,
      callback
    ) {
      const storageRef = firebase.storage().ref();
      const that = this;
      let galleryUrlList = [];
      let logoUrl = "";
      let uploadProgress = 0;

      if (catererName && logoFile) {
        const imageRef = storageRef.child(
          that.currentEventCollection +
            "/" +
            catererName +
            "/" +
            logoFile[0].name
        );
        const uploadTask = imageRef.put(logoFile[0]);

        uploadTask.on(
          firebase.storage.TaskEvent.STATE_CHANGED,
          function (/*snapshot*/) {
            //                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          function (error) {
            switch (error.code) {
              case "storage/unauthorized":
                // eslint-disable-next-line
                console.log("unauthorized access for user");
                break;
              case "storage/canceled":
                // eslint-disable-next-line
                console.log("upload canceled");
                break;
              case "storage/unknown":
                // eslint-disable-next-line
                console.log("unknown error: ", error.serverResponse);
                break;
            }
          },
          function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                logoUrl = downloadURL;

                if (galleryFiles && catererName) {
                  Array.from(galleryFiles).forEach(function (file) {
                    const imageRef = storageRef.child(
                      that.currentEventCollection +
                        "/" +
                        catererName +
                        "/" +
                        file.name
                    );
                    const uploadTask = imageRef.put(file);

                    uploadTask.on(
                      firebase.storage.TaskEvent.STATE_CHANGED,
                      function (/*snapshot*/) {
                        //                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                      },
                      function (error) {
                        switch (error.code) {
                          case "storage/unauthorized":
                            // eslint-disable-next-line
                            console.log("unauthorized access for user");
                            break;
                          case "storage/canceled":
                            // eslint-disable-next-line
                            console.log("upload canceled");
                            break;
                          case "storage/unknown":
                            // eslint-disable-next-line
                            console.log(
                              "unknown error: ",
                              error.serverResponse
                            );
                            break;
                        }
                      },
                      function () {
                        uploadTask.snapshot.ref
                          .getDownloadURL()
                          .then(function (downloadURL) {
                            galleryUrlList.push(downloadURL);
                            uploadProgress++;

                            if (uploadProgress === galleryFiles.length) {
                              callback(logoUrl, galleryUrlList);
                            }
                          });
                      }
                    );
                  });
                } else {
                  callback(logoUrl, false);
                }
              });
          }
        );
      }
    },

    resetCatererForm: function () {
      this.$refs.addCatererFormRef.reset();

      this.logoUploadFileString = "";
      this.galleryUploadFileString = "";

      this.logoFileList = null;
      this.galleryFileList = null;
    },
    addCaterer: function () {
      const that = this;
      const submitData = that.$data.addCatererFormData;

      that.processingSubmit = true;

      that.uploadCatererImages(
        submitData.name,
        that.logoFileList,
        that.galleryFileList,
        function (logoUrl, galleryUrlList) {
          firebaseCfg.db
            .collection(that.currentEventCollection)
            .add({
              createDate: firebase.firestore.Timestamp.fromDate(new Date()),
              name: submitData.name ? submitData.name : "",
              offering: submitData.offering ? submitData.offering : "",
              description: submitData.description ? submitData.description : "",
              logo: logoUrl ? logoUrl : "",
              images: galleryUrlList ? galleryUrlList : [],
              instagram: submitData.instagram ? submitData.instagram : "",
              facebook: submitData.facebook ? submitData.facebook : "",
            })
            .then(function () {
              that.pushNotification("green", "Dlībnieks pievienots.");

              that.resetCatererForm();
              that.$refs.currentEventCatererBlock.updateCaterers(
                that.currentEventCollection
              );

              that.processingSubmit = false;
            })
            .catch(function (error) {
              console.log(error);
              that.pushNotification("red", "Kļūda pievienojot dalībnieku.");
              that.processingSubmit = false;
            });
        }
      );
    },
  },
  mounted() {
    const that = this;

    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        that.isAuthenticated = true;
      } else {
        that.isAuthenticated = false;
      }
    });
  },
};
</script>
<style>
.caterers__carousel .v-image__image {
  background-size: contain !important;
  background-color: #000 !important;
}
.error--text .v-messages__message {
  color: red !important;
}
.caterers__dialog {
  margin-top: 80px !important;
}

.previous-events-container .v-expansion-panel-header {
  justify-content: center;
}
.previous-events-container
  .v-expansion-panel-header
  > .v-expansion-panel-header__icon {
  margin: unset;
}
.previous-events-container .v-expansion-panel__body {
  padding: 15px 0;
}
</style>
<style scoped>
.main-section {
  display: flex;
  margin: 0 35px;
}
.partners {
  align-self: center;
  align-content: center;
  overflow: hidden;
  margin: 120px 35px 60px;
  flex-direction: column;
  text-align: center;
  max-width: 900px;
}
.partners__content {
  max-width: 900px;
  margin: 30px 0 0;
  align-items: center;
  color: #fff;
  position: relative;
  justify-content: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.partner-item img {
  max-height: 125px;
  max-width: 255px;
  margin: 15px;
}
.caterers {
  align-self: center;
  overflow: hidden;
  margin: 120px 35px 0;
  flex-direction: column;
  width: 100%;
}

.caterers h1 {
  text-align: center;
}
.previous-events-container h1 {
  margin: 0 0 30px;
}
.previous-ecents__expansion-wrap {
  margin-bottom: 5px;
}
.caterers__expansion-panel h2 {
  text-align: center;
}
.caterers__add-more {
  width: 320px;
  margin: 0 auto;
}
.hosts {
  align-self: center;
  align-content: center;
  overflow: hidden;
  margin: 120px 35px 0;
  flex-direction: column;
  max-width: 900px;
}
.hosts h1 {
  text-align: center;
}
.hosts__text {
  color: #000;
  font-size: 16px;
}
.hosts__text .router-link {
  color: #79c616;
  text-decoration: none;
}
.hosts__content {
  max-width: 900px;
  margin: 30px 0 0;
  align-items: center;
  color: #fff;
  position: relative;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
}

.festival-page {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.festival-page h1 {
  font-size: 2em;
}
.punch-line-section {
  text-shadow: 1px 1px #404040;
  height: 100vh;
  max-width: 1200px;
  display: flex;
  align-self: center;
  width: 100%;
  position: absolute;
}
.punch-line-tile {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  z-index: 101;
  position: relative;
  color: #fff;
  width: 100%;
  text-shadow: 2px 2px 2px #000;
  text-align: center;
  line-height: normal;
  cursor: default;
}

.punch-line-tile__text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 25px;
  /*color: #464646;*/
}
.punch-line-tile__description {
  max-width: 535px;
  font-size: 25px;
  font-weight: bold;
  margin: 25px 0;
  opacity: 0;
  transition: opacity 0.3s ease-in;
}
.punch-line-tile--moved .punch-line-tile__description {
  opacity: 1;
}
.punch-line-tile--moved .punch-line-tile__description {
  opacity: 1;
}
.punch-line-tile__riga-year {
  font-size: 1.4em;
}
.punch-line-tile__event-name {
  font-size: 4em;
  max-width: 470px;
  margin: 10px 0 10px 0;
  font-weight: bold;
}
.punch-line-tile__event-name--justified {
  /*word-spacing: 30px;*/
}
.punch-line-tile__event-name span {
  font-size: 1.8em;
}
.punch-line-tile__month-date {
  font-size: 2em;
  display: flex;
  justify-content: center;
  margin: 25px 0 40px;
}
.punch-line-tile__month-date span {
  font-size: 65%;
  margin-left: 10px;
}
.punch-line-tile__moto {
  font-size: 2em;
}

@media (max-width: 600px) {
  .punch-line-tile {
    flex-direction: column;
  }
  .punch-line-tile__event-name span {
    font-size: 2em;
  }
  .punch-line-tile__event-name {
    font-size: 2.5em;
  }
  .punch-line-tile__month-date {
    font-size: 1.3em;
  }
  .punch-line-tile__moto {
    font-size: 1.3em;
  }
}

section.description {
  justify-content: center;
  margin: 120px 35px 0;
  font-size: 16px;
}
.description__text {
  max-width: 900px;
}
.join-event {
  align-self: center;
  align-content: center;
  overflow: hidden;
  margin: 120px 35px 0;
  flex-direction: column;
  max-width: 900px;
}
.location {
  justify-content: space-evenly;
  align-self: center;
  width: 100%;
  position: relative;
  font-size: 16px;
  margin-top: 120px;
}
.background-img {
  height: 100%;
  position: absolute;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
/*.background-img__location {*/
/*background: url(../assets/img/carrots.jpeg);*/
/*background-attachment: fixed;*/
/*filter: brightness(0.7);*/
/*opacity: 0.2;*/
/*}*/
.background-overlay {
  height: 100%;
  position: absolute;
  width: 100%;
  opacity: 0.7;
}
.background-overlay__location {
  background: #000;
}
.location__content {
  position: relative;
  display: flex;
  width: 100%;

  flex-direction: row;
  align-items: center;
}
.location__map {
  width: 100%;
  max-width: 1000px;
  position: relative;
  height: 350px;
  margin-right: 15px;
}
.location__map iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.location__description {
  max-width: 550px;
  color: #fff;
  margin: 35px;
}
.location__description p {
  margin-bottom: 5px;
}
.location__description a {
  color: #79c616;
  text-decoration: none;
}
@media (max-width: 800px) {
  .location__content {
    flex-direction: column;
  }
  .location__map {
    margin: 0;
  }
  .punch-line-tile__text {
    margin-top: 100px;
  }
  .partners__content {
    flex-direction: column;
    max-width: 700px;
  }
  @media (max-width: 600px) {
    .punch-line-section {
      height: 90vh;
    }
    section.description {
      margin-top: 120px;
    }
    .festival-page__header-img {
      background-attachment: scroll;
    }
  }
}
</style>
